import { useState } from "react";
import { Alert, Button, ButtonGroup, Col, Dropdown, Form, ListGroup, Modal, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { clearEmployees, getAllActiveEmployees } from "../../../redux/employees/actions";
import toastr from "toastr";

const EmployeeSearch = ({ showModal, setShowModal, setEmployeesList, setEmployeeListSelected, employeeListSelected, employeeList }) => {
    const dispatch = useDispatch();
    const [validatedEmployee, setValidatedEmployee] = useState(false);
    const filtersEmployees = [
        { id: "codigo", desc: "Código" },
        { id: "nombre", desc: "Nombre" },
    ];
    const [tipoBusquedaEmployee, setTipoBusquedaEmployee] = useState(
        filtersEmployees[0]
    );

    //Redux
    const { employees, employeesFaild, loaderAllEmployees } = useSelector(
        (store) => store.employees
    );

    //Methods
    const onSearchEmployee = (e) => {
        //e.preventDefault();
        if (e.key === "Enter") {
            if (!e.target.value.trim()) {
                setValidatedEmployee(true);
            } else {
                setValidatedEmployee(false);
                dispatch(
                    getAllActiveEmployees({
                        tipo_busqueda: tipoBusquedaEmployee.id,
                        filter: e.target.value,
                    })
                );
            }
        }
    };

    const _selectEmployee = (employee) => {

        const existsEmployeeListSelected = employeeListSelected.find((id)=> id === employee.id )
        const existsEmployeeList = employeeList.find((emp) => emp.id === employee.id)
        // Check if the employee is already selected
        if (existsEmployeeListSelected && existsEmployeeList) {
            toastr.warning("Colaborador ya seleccionado");
            return;
        }
        setEmployeesList((prev) => [...prev, employee]);
        setEmployeeListSelected((prev) => [...prev, employee.id]);
    }
    const _clearEmployees = (e) => {
        setValidatedEmployee(false);
        dispatch(clearEmployees());
    }
    return (
        <Modal
            show={showModal}
            onHide={() => {
                _clearEmployees()
                setShowModal(false)
            }}
        >
            <Modal.Header closeButton>
                <Modal.Title>Buscar Colaborador</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="justify-content-end align-items-center flex-nowrap">
                    {!!employeesFaild && (
                        <Alert variant="danger" className={"mt-4 mb-1 mx-3"}>
                            {employeesFaild}
                        </Alert>
                    )}
                    <Col>
                        <ButtonGroup>
                            <OverlayTrigger
                                placement="auto"
                                overlay={<Tooltip>Seleccionar Filtrado</Tooltip>}
                            >
                                <Dropdown className="ml-3">
                                    <Dropdown.Toggle
                                        variant="light"
                                        className="btn-sm font rounded-pill"
                                    >
                                        <i className="material-icons">filter_list</i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {filtersEmployees.map((item) => (
                                            <Dropdown.Item
                                                onClick={() => setTipoBusquedaEmployee(item)}
                                                key={item.id}
                                            >
                                                {item.desc}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </OverlayTrigger>
                        </ButtonGroup>
                    </Col>
                    <Col>
                        <Form.Label className="m-0" htmlFor="filterEmployee">
                            <b>{tipoBusquedaEmployee.desc}:</b>
                        </Form.Label>
                    </Col>
                    <Col xs={12} sm={8} md={6} lg={6}>
                        <Form.Control
                            id="filterEmployee"
                            name="filterEmployee"
                            required
                            className={`rounded-pill form-control-sm ${validatedEmployee ? "is-invalid" : ""
                                }`}
                            type="search"
                            onKeyDown={onSearchEmployee}
                        //value={searchEmployee}
                        //onChange={e => setSearchEmployee(e.target.value)}
                        ></Form.Control>
                        <Form.Control.Feedback type="invalid">
                            **Campo requerido
                        </Form.Control.Feedback>
                    </Col>

                </Row>
                <div className="my-3">
                    {loaderAllEmployees ? (
                        <div className="d-flex justify-content-center">
                            <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                            />
                        </div>
                    ) : employees.length > 0 ? (
                        <ListGroup variant="flush">
                            {employees.map((employee) => (
                                <ListGroup.Item className="d-flex flex-wrap justify-content-between align-items-center">
                                    <p className="m-0">
                                        {employee.codigo} {employee.nombre}
                                    </p>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>
                                                Seleccionar Colaborador
                                            </Tooltip>
                                        }>
                                        <Button
                                            onClick={() => _selectEmployee(employee)}
                                            size="sm"
                                            variant="primary"
                                            className="rounded-circle"
                                        >
                                            <i className="material-icons">person_add</i>
                                        </Button>
                                    </OverlayTrigger>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    ) : (
                        <Alert variant="info" className="my-4">
                            Sin registros que mostrar.
                        </Alert>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    className="rounded-pill"
                    onClick={() => {
                        _clearEmployees()
                        setShowModal(false)
                    }}
                >
                    Cerrar
                </Button>
            </Modal.Footer>


        </Modal>
    )
}

export default EmployeeSearch;